// FLUID BG : the live background's engine settings as named values —
// src/utils/fluidBgHash.js encodes them into the share hash the fluid-bg
// package needs, and FluidTuner (src/components/FluidTuner) edits them live.
// GENERATED : FluidTuner's "Save configuration" rewrites this entire file
// (dev server only) — hand edits are fine, but get replaced on the next save.
const FLUID_BG_SETTINGS = {
  "speed": 3.2,
  "zoom": 3.4,
  "warp": 3,
  "grain": 0.32,
  "sym": 0,
  "pixel": 3,
  "dot": 16,
  "dots": false,
  "thresh": 0.51,
  "screen": "dither",
  "seed": 4.2,
  "colors": [
    "#000000",
    "#303c41",
    "#2093ac",
    "#0ff0ff"
  ],
  "field": "pursuit",
  "layer": {
    "field": "flow",
    "blend": "difference",
    "mix": 66
  },
  "layer2": {
    "field": "marble",
    "blend": "difference",
    "mix": 17
  },
  "material": "none",
  "lens": "none",
  "lensAmt": 100,
  "eye": {
    "melt": true,
    "blend": 100,
    "liquify": 10,
    "scale": 19,
    "pixel": 2,
    "showDrip": false
  }
};

export default FLUID_BG_SETTINGS;
